import { useDocumentClassifications } from '~/entities/document'

export function useClassification({ documentKey }: { documentKey: string }) {
  const { data } = useDocumentClassifications({ documentKey })

  if (!data.items || data.items?.length === 0) {
    return { confidenceScore: 0, explanation: '' }
  }

  const confidenceScore = data.items[0].categories[0].subcategories?.[0]?.confidence_score || 0
  const explanation = data.items[0].categories[0].subcategories?.[0]?.explanation || ''
  return { confidenceScore, explanation }
}
